"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MapMarker {
    constructor(mapMarkerOptions) {
        this.geoData = mapMarkerOptions.geoData || '';
        this.iconImg = mapMarkerOptions.iconImg || '/images/map/resources/tube-icon.svg';
        this.code = mapMarkerOptions.code || '';
        this.enableHoverInteraction = mapMarkerOptions.enableHoverInteraction || false;
        this.enableSelectInteraction = mapMarkerOptions.enableSelectInteraction || false;
        this.color = mapMarkerOptions.color || '#111';
    }
}
exports.default = MapMarker;
